import { AbstractVideo } from "./AbstractVideo.js";

export class YoutubeVideo extends AbstractVideo {
    private static _uid: number = 1;
    private static _loadedApi: boolean = false;
    private static _loadingApi: boolean = false;
    private static _waitForReady: YoutubeVideo[] = [];

    private _signature: HTMLAnchorElement;
    private _uid: string = "youtube-video-" + YoutubeVideo._uid++;
    private _player: YT.Player = null;
    private _src: string = "";
    private _video: HTMLDivElement;
    private _overlay: HTMLDivElement;
    private _updateInterval: any = null;

    constructor() {
        super();

        this.element = document.createElement("div");
        this.element.className = "e5-video youtube";
        this.element.innerHTML = `
            <div id="${this._uid}" class="e5-video__video"></div>
            <div class="e5-video__overlay e5-hidden">
                <a class="e5-video__signature" target="_blank"></a>
            </div>
            `;
        this._video = this.element.querySelector(".e5-video__video");
        this._overlay = this.element.querySelector(".e5-video__overlay");
        this._signature = this.element.querySelector(".e5-video__signature");

        this.loadYoutubeApi();

        this._overlay.addEventListener("click", (e) => {
            if (!this.ready || e.target != this._overlay)
                return;
            var state = this._player.getPlayerState();
            if (state === 1)//Playing
                this._player.pauseVideo();
            else
                this._player.playVideo();
        });

        // Player.onTick.add(this.updateTime, this);
        this._updateInterval = setInterval(() => this.update(), 100);
    }

    private update(): void {
        var time: number = 0;
        if (!this.ready) {
            time = 0;
        } else {
            time = this._player.getCurrentTime();
        }
        if (this.time !== time) {
            this.onTimeChange.dispatch(time);
        }

        var buffer: number = 0;
        if (!this.ready) {
            buffer = 0;
        } else {
            buffer = this._player.getVideoLoadedFraction();
        }

        if (this.buffer !== buffer) {
            this.onBufferChange.dispatch(buffer);
        }
    }

    private loadYoutubeApi(): void {
        if (YoutubeVideo._loadedApi) {
            this.handleApiLoaded();
            return;
        }

        if (YoutubeVideo._loadingApi) {
            YoutubeVideo._waitForReady.push(this);
            return;
        }

        YoutubeVideo._loadingApi = true;
        YoutubeVideo._waitForReady.push(this);
        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    private handlePlayerStateChange(e: YT.OnStateChangeEvent): void {
        this.state = e.data as any;
        var duration = this._player.getDuration();
        if (this.duration !== duration)
            this.onDurationChange.dispatch(duration);
        this._overlay.classList.toggle("e5-video__overlay--active", (e.data !== 1 && e.data !== 3));
        this.onStateChange.dispatch(e.data as any);
        this.update();
    }

    public static handleApiLoaded(): void {
        for (var v of YoutubeVideo._waitForReady)
            v.handleApiLoaded();
        YoutubeVideo._waitForReady = [];
    }

    private handleApiLoaded(): void {
        this._player = new YT.Player(this._video.id, {
            width: "100%",
            height: "100%",
            playerVars: {
                autohide: YT.AutoHide.HideAllControls,
                autoplay: YT.AutoPlay.NoAutoPlay,
                cc_load_policy: YT.ClosedCaptionsLoadPolicy.UserDefault,
                controls: YT.Controls.Hide,
                playsinline: YT.PlaysInline.Inline,
                disablekb: YT.KeyboardControls.Disable,
                fs: YT.FullscreenButton.Hide,
                loop: YT.Loop.SinglePlay,
                rel: YT.RelatedVideos.Hide,
                showinfo: YT.ShowInfo.Hide,
                modestbranding: YT.ModestBranding.Modest,
                start: 0
            },
            // playerVars: {
            //     autohide: 1,
            //     autoplay: 0,
            //     cc_load_policy: 3,
            //     controls: 0,
            //     playsinline: 1,
            //     disablekb: 1,
            //     fs: 0,
            //     loop: 0,
            //     rel: 0,
            //     showinfo: 0,
            //     modestbranding: 1,
            //     start: 0
            // },
            events: {
                'onReady': () => this.handlePlayerReady(),
                'onStateChange': (e) => this.handlePlayerStateChange(e)
            }
        });
    }

    private handlePlayerReady(): void {
        this.ready = true;
        this.onReady.dispatch();
        if (this._src)
            this.load(this._src);
    }

    public load(src: string): void {
        this._src = src;

        var url = `https://img.youtube.com/vi/${src}/hqdefault.jpg`;
        this._overlay.style.backgroundImage = `url(${url})`;
        this._signature.href = `https://www.youtube.com/watch?v=${src}`;
        this._overlay.classList.add("e5-video__overlay--active");

        if (!this.ready) {
            return;
        }

        this._player.cueVideoById(src);
    }

    public play(): void {
        this._player.playVideo();
    }

    public pause(): void {
        this._player.pauseVideo();
    }

    public seek(time: number): void {
        this._player.seekTo(time, true);
    }

    public dispose(): void {
        clearInterval(this._updateInterval);
        if (this._player)
            this._player.destroy();
        this._player = null;
        YoutubeVideo._waitForReady.splice(YoutubeVideo._waitForReady.indexOf(this), 1);
        super.dispose();
    }
}

function onYouTubeIframeAPIReady() {
    YoutubeVideo.handleApiLoaded();
}